import { useState, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';

import GlobalImageLoader from "../src/components/loader/GlobalImageLoader.jsx"
import Seo from "./components/Seo.jsx";

import Main from './pages/main/main.js';
import About from './pages/about/about.js';
import Team from './pages/team/team.js';
import Subscribe from './pages/subscribe/subscribe.jsx';
// import Education from './pages/educator/education.js';
import Education from './pages/educator/new_education.js';
import Gallery from './pages/gallery/gallery.js';
import Classes from './pages/classes/classes.js';
import Community from './pages/community/community.js';
import RobotictKits from './pages/robotic_kit/roboticKit.js';
import Tutorials from './pages/tutorials/tutorials.jsx';
// import KickStarter from './pages/kickstarter/kickstarter.js';
import Shop from './pages/shop/shop.js';
import EmailPopup from './pages/emailPopup/emailPopup.js';
import { useEmailPopup } from './components/emailPopup/useEmailPopup.js';
import { useAnalytics } from './hooks/useAnalytics.js';
// import AboutRobotic from './pages/aboutRobotic/aboutRobotic.js';
// import EducationRedirect from "./pages/EducationRedirect";
import ShopRedirect from "./pages/ShopRedirect";

//vercel push

// Fonts
import './assets/fonts/fonts.css';

import { BackButtonProvider, useBackButton } from "./BackButtonContext.js";
import TermsOfService from './pages/termsofservice/termsofservice.js';
import PrivacyPolicy from './pages/privacypolicy/privacypolicy.js';
import ContactUs from './pages/contactUs/contactUs.js';

// This function scroll to top when redirecting
function ScrollToTop() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location])
  return null
}

// Google Analytics Tracker
// React requires hooks to run inside components.
function AnalyticsTracker() {
  useAnalytics();   // runs your hook globally
  return null;      // renders nothing
}

function App() {
  const [show, setShow] = useState(false);
  useEmailPopup(() => setShow(true));

  return (
    <>
      <BackButtonProvider> {/* Wrap the entire app */}
      <div id="scroll-container">
        <Router>
          {/*
            Per-route <title>, description, canonical, OG and Twitter tags.
            Rendered ONCE here rather than in each page: Seo reads the current
            path from react-router and looks it up in src/seo/pageMeta.js, so
            every route is covered automatically. Add new routes to pageMeta.js
            and public/sitemap.xml, not here.
          */}
          <Seo />

          {/* for tracking use to understand who's visiting our webpage */}
          <AnalyticsTracker />
          <ScrollToTop />
          <BackButtonTracker />

          {show && <EmailPopup onClose={() => setShow(false)} />}

          <Routes>
            <Route element={<GlobalImageLoader />}>
              <Route path='/' element={<Main />} />
              <Route path='/about' element={<About />} />
              <Route path='/team' element={<Team />} />
              <Route path='/education' element={<Education />} />
              <Route path='/subscribe' element={<Subscribe />} />
              {/* <Route path="/kickstarter" element={<KickStarter />} /> */}
              <Route path='/roboticskits' element={<Shop />} />
              <Route path="/tutorials" element={< Tutorials />} />
              <Route path="/terms" element={< TermsOfService />} />
              <Route path="/privacy-policy" element={< PrivacyPolicy />} />
              <Route path="/contact-us" element={< ContactUs />} />
              {/* <Route path="/about-robotic" element={< AboutRobotic />} /> */}
              <Route path="/robotickits" element={< RobotictKits />} />
              <Route path="/gallery" element={ < Gallery /> } />
              <Route path="/classes" element={ < Classes /> } />
              <Route path="/community" element={ < Community /> } />

              {/* Redirect URLs */}
              {/* <Route path="/education" element={<EducationRedirect />} /> */}
              <Route path="/shop" element={<ShopRedirect />} />
            </Route>
          </Routes>
        </Router>
      </div>
      </BackButtonProvider>
    </>
    
  );
}

function BackButtonTracker() {
  const location = useLocation();
  const { setIsBackButtonPressed } = useBackButton();
  const prevPathRef = useRef(null);

  useEffect(() => {
    if (prevPathRef.current && prevPathRef.current !== "/" && location.pathname === "/") {
      setIsBackButtonPressed(true); // Set back button flag
    } else {
      setIsBackButtonPressed(false); // Reset if normal navigation
    }

    prevPathRef.current = location.pathname;
  }, [location, setIsBackButtonPressed]);

  return null; // This component does not render anything
}

export default App;
